<template>
    <div class="list-item" @click="gotoDetail">
      <div class="tag-box" v-if="isNote"> 需求贴 </div>
      <div class="top-box">
        <div class="mine-class" v-if="!isNote">
          <div>发布人</div>
        </div>
        <div
          class="user-box"
          v-if="item.izMe != 'Y'"
          :style="isNote ? 'margin-top:40px' : ''"
        >
          <div class="avatar">
            <img :src="item.avatar" alt="" />
          </div>
          <div class="name">{{ item.name }}</div>
          <div
            style="display: flex; align-items: center"
            v-if="item.izOfficial == 'Y'"
          >
            <van-tag plain type="primary">官方</van-tag>
          </div>
        </div>
        <div class="label-type" v-if="item.requireType != '其他' && !isNote">
          {{ item.requireType }}
        </div>
      </div>
      <div class="school-info">
        <div class="title">
          <div
            ><img :src="require('@/assets/miImgs/imgs/icon2.png')" alt=""
          /></div>
          <div>院校信息</div>
        </div>
        <div class="info">
          <div class="info-item">
            <div>学校：</div>
            <div>{{ item.school }}</div>
          </div>
          <div class="info-item">
            <div>学历：</div>
            <div>{{ item.edu || "不限" }}</div>
          </div>
          <div class="info-item">
            <div>学院：</div>
            <div>{{ item.college || "不限" }}</div>
          </div>
          <div class="info-item">
            <div>专业：</div>
            <div>{{ item.major || "不限" }}</div>
          </div>
        </div>
      </div>
      <div class="content-box">
        <div class="title">
          <div>费用（元）:</div>
          <div>{{ item.money }}</div>
        </div>
        <div class="title" v-if="item.helpMoney > 0">
          <div>帮找费用（元）:</div>
          <div>{{ item.helpMoney }}</div>
        </div>
        <div style="margin-top: 10px">
          <div class="title">需求详情：</div>
        </div>
        <div class="content-text">{{item.content}}</div>
      </div>
      <div style="margin-top: 10px; display: flex; justify-content: center">
        <!-- <div class="detail-box" @click.stop="gotoDetail"> 查看详情 </div> -->
          <div
            class="remove-btn"
            v-if="item.izMe == 'Y'"
            @click.stop="removeRequireAction(item)"
            >撤单</div
          >
          <div v-else class="actions">
            <div class="btn" @click.stop="shareAction">帮找</div>
            <div class="btn" @click.stop="takeRequireAction">接单</div>
          </div>
      </div>
    </div>
  </template>

<script>
    import cryptoDES from "@/util/cryptoDES";
    export default {
        data() {
            return {};
        },
        props: {
            item: {
                typeof: Object,
                default: () => {},
            },
            isNote: {
                typeof: Boolean,
                default: () => false,
            },
        },
        methods: {
            gotoDetail() {
                console.log('this.item', this.item)
                let query = {
                    id: cryptoDES.encrypt(this.item.id)
                };
                this.$router.push({
                    path: "mirequire/detail",
                    query: query,
                });
            },
            shareAction() {
            
                this.$emit("shareAction");
            },
            removeRequireAction(e) {
                let that = this;
            },
            takeRequireAction() {
                this.$emit("shareAction");
            },
        },
    };
</script>

<style lang="scss" scoped>
    .list-item {
        background: #fff;
        margin-bottom: 10px;
        width: 100%;
        border-radius: 10px;
        position: relative;
        padding: 5px 0;
        .top-box {
            position: relative;
            .mine-class {
                font-size: 12px;
                color: #3d7eff;
            }
            .user-box {
                display: flex;
                align-content: center;
                margin: 5px 0;
                margin-left: 5px;
                .name {
                    font-size: 13px;
                    margin-left: 8px;
                    line-height: 25px;
                    margin-right: 10px;
                    max-width: 75px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
                .avatar {
                    width: 25px;
                    height: 25px;
                    img {
                        height: 100%;
                        width: 100%;
                        border-radius: 50%;
                    }
                }
            }
            .label-type {
                position: absolute;
                right: 0px;
                top: 0px;
                padding: 5px 8px;
                background: #3d7eff;
                color: #ffffff;
                font-size: 10px;
                border-radius: 5px;
            }
        }
        .school-info {
            border-bottom: solid 1px #ebebeb;
            padding-bottom: 10px;
            margin-left: 5px;
            .title {
                margin-top: 10px;
                display: flex;
                align-content: center;
                color: #333;
                font-size: 13px;
                img {
                    width: 15px;
                    height: 15px;
                    margin-right: 5px;
                }
            }
            .info-item {
                margin-top: 5px;
                font-size: 12px;
                display: flex;
                color: #666;
            }
        }
        .content-box {
            padding-top: 10px;
            .title {
                font-size: 13px;
                font-weight: 600;
                margin-left: 5px;
                display: flex;
            }
            .content-text {
                margin-left: 5px;
                font-size: 13px;
                color: #333;
                margin-top: 10px;
                line-height: 20px;
                overflow: hidden;
                text-overflow: ellipsis;
                /* 超出部分省略号 */
                word-break: break-all;
                /* break-all(允许在单词内换行。) */
                display: -webkit-box;
                /* 对象作为伸缩盒子模型显示 */
                -webkit-box-orient: vertical;
                /* 设置或检索伸缩盒对象的子元素的排列方式 */
                -webkit-line-clamp: 2;
                /* 显示的行数 */
                // max-height: 80px;
                /* 设置最大高度，根据行高，要几行乘以几倍 */
            }
        }
        .actions {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 15px;
            padding: 0 10px;
            width: 100%;
            .btn {
                color: #ffffff;
                background: #3d7eff;
                padding: 5px 0;
                width: 45%;
                text-align: center;
                border-radius: 20px;
                font-size: 12px;
            }
        }
        .remove-btn {
            color: #ffffff;
            background: #3d7eff;
            padding: 5px 30px;
            border-radius: 20px;
            text-align: center;
            margin: 0 30px;
        }
    }
    
    .detail-box {
        background: rgba($color: #3d7eff, $alpha: 0.8);
        line-height: 35px;
        height: 35px;
        width: 80%;
        border-radius: 17px;
        text-align: center;
        color: #fff;
    }
    
    .tag-box {
        font-size: 14px;
        font-weight: 600;
        position: absolute;
        top: 0;
        background: rgba($color: #3d7eff, $alpha: 1);
        left: 0;
        right: 0;
        line-height: 40px;
        text-align: center;
        color: #fff;
        z-index: 1;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/MiRequireItem.vue